<template>
  <div class="votemain">

    <van-tabs title-active-color="#FF6C1A" color="#fff" v-model="active" @click="onClickTab">
      <van-tab :title="item.title" :name="item.name" v-for="(item, index) in tabs" :key="index">
        <van-pull-refresh v-model="loading" @refresh="onRefresh">
          <div class="voteListBox">
            <div class="publicMain">
              <div v-if="dataList.length > 0" lazy-load style="overflow:hidden">
                <div class="item" v-for="(item, index) in dataList" :key="index" v-lazy="item" @click="getInfo(item)">
                  <img v-if="item.gszt == 2" class="icon" src="../../assets/img/img_ing.png" alt="" />
                  <img v-else-if="item.gszt == 3" class="icon" src="../../assets/img/img_finish.png" alt="" />
                  <div class="name">{{ item.gsmc }}</div>
                  <div class="info">

                    <div class="box-time">
                      <div class="time">发布时间:{{ item.gsfqsj }}</div>
                    </div>

                    <div class="VoteType">{{ item.gslx | gslxMsg }}</div>


                  </div>
                </div>
              </div>
              <!-- -->
              <div v-if="!dataList.length && !loading">
                <nodata></nodata>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-tab>

      <van-tab>
        <template #title>
          <van-icon name="filter-o" />筛选
        </template>
        <van-pull-refresh v-model="loading" @refresh="onRefresh">
          <div class="voteListBox">
            <div class="publicMain">
              <div v-if="dataList.length > 0" lazy-load style="overflow:hidden">
                <div class="item" v-for="(item, index) in dataList" :key="index" v-lazy="item" @click="getInfo(item)">
                  <img v-if="item.gszt == 2" class="icon" src="../../assets/img/img_ing.png" alt="" />
                  <img v-else-if="item.gszt == 3" class="icon" src="../../assets/img/img_finish.png" alt="" />
                  <div class="name">{{ item.gsmc }}</div>
                  <div class="info">

                    <div class="box-time">
                      <div class="time">发布时间:{{ item.gsfqsj }}</div>
                    </div>

                    <div class="VoteType">{{ item.gslx | gslxMsg }}</div>


                  </div>
                </div>
              </div>
              <!-- -->
              <div v-if="!dataList.length && !loading">
                <nodata></nodata>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-tab>

      <van-popup v-model="showSerach" position="top">
        <div class="popBox">

          <span>投票状态</span>
          <div class="tagBox">
            <van-tag v-for="(item, index) in voteStatusList" :key="'type_' + index" :color="
              params.gszt == item.val ? '#FF6C1A' : '#F7F7F7'
            " :text-color="params.gszt == item.val ? '#FF6C1A' : '#999998'" @click="chageStatusTag(item.val)" plain
              type="primary" size="large">{{ item.name }}</van-tag>
          </div>

          <div class="buttonBox">
            <button class="reset" @click="reset">重置</button>
            <button class="sure" @click="sure">确认</button>
          </div>
        </div>
      </van-popup>
    </van-tabs>
  </div>
</template>

<script>
import nodata from "../components/noData.vue";
import api from "@/api/public.js";

export default {
  components: {
    publicItem: () => import("./../components/publicItem.vue"),
    nodata,
  },
  data() {
    return {
      loading: false,
      showSerach: false,
      active: '',
      voteStatusList: [
        { name: "全部", val: -1 },
        { name: "进行中", val: 2 },
        { name: "已结束 ", val: 3 },
      ],
      tabs: [
        {
          title: "全部",
          name: '',
        },
        {
          title: "使用公示",
          name: 0,
        },
        {
          title: "投票公示",
          name: 1,
        },
        {
          title: "验收公示",
          name: 2,
        },
      ],
      params: {
        gszt: -1,
        gslx: ""
      },
      wyqyId: "",
      dataList: [
        // {
        //   gsmc: "哈哈哈哈哈",
        //   gslx: "0"
        // },
      ],
    };
  },
  created() {
    this.wyqyId = Number(sessionStorage.getItem('wyqy'))
  },
  mounted() {

    this.getList();
  },

  filters: {
    gslxMsg(val) {
      if (val == 0) {
        return '使用公示'
      } else if (val == 1) {
        return '投票公示'
      } else {
        return '验收公示'
      }
    },
    btn(val) {
      if (val == 2) {
        return '进行中'
      } else if (val == 3) {
        return '已结束'
      }
    }
  },
  methods: {
    getList() {

      let params = {
        gslx: this.params.gslx,
        openId: sessionStorage.getItem('openId'),
        wyqyId: this.wyqyId,
        fwId: sessionStorage.getItem('fwId'),
        gszt: this.params.gszt
      };
      this.dataList = []
      this.loading = true;
      api
        .publicList(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.dataList = res.data.data;
            this.dataList.forEach(item => {
              item.gsfqsj = item.gsfqsj.slice(0, 10)
            })
            if (this.dataList.length > 0) {
              this.loading = false;
            } else {
              this.loading = false;
            }
          }
        })
        .catch((err) => {
          this.$toast.fail({
            message: err,
          })
        });
    },
    getInfo(item) {
      if (item.gslx == 0) {
        // this.$router.push({
        //   path: "/useDetail",
        //   query: { id: item.id, active: this.active },
        // });
        location.href = '/useDetail' + '?id=' + item.id + '&active=' + this.active
      } else if (item.gslx == 1) {
        // this.$router.push({
        //   path: "/publicVote",
        //   query: { id: item.id, active: this.active },
        // });

        location.href = '/publicVote' + '?id=' + item.id + '&active=' + this.active
      } else {
        // this.$router.push({
        //   path: "/publicDetail",
        //   query: { id: item.id, active: this.active },
        // });
        location.href = '/publicDetail' + '?id=' + item.id + '&active=' + this.active

      }
    },
    sure() {
      this.getList()
      this.showSerach = false;
    },
    reset() {
      this.showSerach = false;
      this.params.gszt = -1
      this.params.gslx = ''
      this.getList()
    },
    chageStatusTag(val) {
      console.log('val', val)
      this.params.gszt = val;
    },
    onRefresh() {
      this.loading = true
      this.getList()
    },
    onClickTab(title) {
      if (title == 4) {
        this.showSerach = true;
      } else {
        this.params.gslx = title
        this.getList();

      }
    },
  },
  computed: {
    refreshLoading() {
      return !this.dataList.length
    }
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.van-nav-bar {
  background-color: #f1f1f1;
  position: sticky;
  top: 0;
  z-index: 99999;
}

.van-nav-bar__content {
  background-color: #f1f1f1;
  position: sticky;
  top: 0;
  z-index: 99999;
}

/deep/.van-tabs__wrap {
  position: sticky;
  top: 0;
  z-index: 99999;
}

.votemain {
  background: #f4f7f9;
  height: 100%;

  .header {
    position: sticky;
    top: 0;
  }
}

.voteListBox {
  min-height: 100vh;
  padding: 0 16px;
  background: #f4f7f9;
  padding-bottom: 60px;
}

.popBox {
  padding: 20px;

  .tagBox {
    margin: 16px 0;

    .van-tag {
      margin: 0 10px;
    }
  }

  .buttonBox {
    display: flex;

    button {
      height: 44px;
      text-align: center;
      border: none;
      border-radius: 22px;
      font-size: 16px;

      &.reset {
        flex: 1;
        color: #ff6c1a;
        border: 1px solid #ff6c1a;
        background-color: #fff;
      }

      &.sure {
        margin-left: 20px;
        flex: 2;
        border: 1px solid #ff6c1a;
        color: #fff;
        background: linear-gradient(133deg, #ff6c19 0%, #ffa370 100%);
      }
    }
  }
}

.publicMain {
  width: 100%;
  height: 100%;
  overflow-x: auto;

  .item {
    position: relative;
    margin-top: 20px;
    width: 100%;
    height: 102px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    padding: 16px;

    .icon {
      position: absolute;
      top: 20px;
      right: -2px;
      width: 56px;
      height: 26px;
    }

    .name {
      width: 70%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 24px;
      font-size: 16px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: #222120;
      line-height: 24px;
    }

    .info {
      display: flex;

      .box-time {
        // flex: 60%;
        margin-top: 15px;
        margin-right: 15px;
        width: 153px;
        height: 30px;
        background: #f7f7f7;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        text-align: center;

        .time {
          margin: auto;
          width: 133px;
          height: 24px;
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999998;
          line-height: 30px;
          // -webkit-background-clip: text;
          // -webkit-text-fill-color: transparent;
        }
      }



      .VoteType {
        margin-top: 15px;
        font-size: 13px;
        text-align: center;
        color: #00c797;
        width: 66px;
        height: 30px;
        line-height: 30px;
        background: rgba(0, 199, 151, 0.05);
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        border: 1px solid #00c797;
      }



    }
  }
}

.voteBottom {
  padding: 0 16px;
  margin-top: 20px;

  button {
    padding: 0 17px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ff6c1a;
    color: #fff;
    border-radius: 30px;
    float: right;
    border: none;
    font-size: 13px;
  }

  .VoteType {
    display: inline-block;
    font-size: 13px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 3px;
  }
}
</style>
